// see https://github.com/Narzerus/angular-permission/issues/40#issuecomment-120043007
import Configs from '../configs/configs'

let directives = {
  only: 'rpOnly',
  except: 'rpExcept',
  state: 'rpState',
  hasPermission: 'hasPermission'
};

let elementBehaviors = {
  'show': function(element) {
    element.removeClass('ng-hide');
  },
  'hide': function(element) {
    element.addClass('ng-hide');
  },
  'disable': function(element) {
    element.attr('disabled', 'disabled');
  }
}

let EXCEPTIONS = {
  UNDEFINED_RP_BEHAVIOR: 'rp-behavior is undefined. Check your spelling, it can be either hide or disable!',
  UNDEFINED_PERMISSION_BEHAVIOR: 'has-permission-behavior is undefined. Check your spelling, it can be either hide or disable!'
}

only.$inject = ['$q', 'Permission'];
except.$inject = ['$q', 'Permission'];
state.$inject = ['$q', 'Permission', '$state'];
hasPermission.$inject = ['currentUser'];

function only($q, Permission) {
  let directive = {
    restrict: 'A',
    link: link
  }
  return directive;

  function link(scope, element, attrs) {
    checkPermissions(directives.only, element, attrs, Permission);
  }
}

function except($q, Permission) {
  let directive = {
    restrict: 'A',
    link: link
  }
  return directive;

  function link(scope, element, attrs) {
    checkPermissions(directives.except, element, attrs, Permission);
  }
}

function state($q, Permission, $state) {
  let directive = {
    restrict: 'A',
    link: link
  }
  return directive;

  function link(scope, element, attrs) {
    let stateConfig = getStateConfiguration(attrs.uiSref);

    if (stateConfig.data && stateConfig.data.permissions)
    {
      let roles = getRolesFromStateConfiguration(stateConfig);

      let customAttributes = {};
      let rule = (stateConfig.data.permissions.only ? directives.only : directives.except);
      customAttributes[rule] = roles;

      checkPermissions(rule, element, customAttributes, Permission);
    }
  }

  function getStateConfiguration(stateName){
    let states = $state.get();
    let stateConfiguration = states.filter(function (route) {
      return (route.name === stateName);
    });

    if(stateConfiguration.length == 0) {
      throw new Error('State is not defined in the router config');
    }

    return stateConfiguration[0];
  }

  function getRolesFromStateConfiguration(stateConfig) {
    let roles = (stateConfig.data.permissions.only ? stateConfig.data.permissions.only : stateConfig.data.permissions.except);
    return roles.join(",");
  }
}

function hasPermission(currentUser) {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      let raw = attrs.hasPermission || '';
      let permissions = raw
        .replace(/\[|]|'|"/gi, '')
        .split(',')
        .map(p => p.trim())
        .filter(Boolean);

      if (!permissions.length) {
        return;
      }

      const behavior = attrs.hasPermissionBehavior || 'hide';
      if (behavior !== 'hide' && behavior !== 'disable') {
        throw new Error(EXCEPTIONS.UNDEFINED_PERMISSION_BEHAVIOR);
      }

      const applyAuthorized = () => {
        elementBehaviors.show(element);
        element.removeAttr('disabled');
      };

      const applyUnauthorized = () => {
        element.removeAttr('disabled');
        elementBehaviors[behavior](element);
      };

      applyUnauthorized();
      currentUser.subscribe(user => {
        if (!user) {
          applyUnauthorized();
          return;
        }

        if (user.hasPermission(permissions)) {
          applyAuthorized();
        } else {
          applyUnauthorized();
        }
      });
    }
  };
}

function validateBehaviorParams(behavior) {
  if(!elementBehaviors[behavior]) {
    throw new Error(EXCEPTIONS.UNDEFINED_RP_BEHAVIOR);
  }
}

function checkPermissions(directiveName, element, attrs, Permission) {
  let roleMap = {};
  let roles = attrs[directiveName].replace(/\[|]|'/gi, '').split(',');
  roleMap[(directiveName === directives.only ? 'only' : 'except')] = roles;

  let behavior = (attrs.rpBehavior ? attrs.rpBehavior : 'hide');
  validateBehaviorParams(behavior);

  let authorizing = Permission.authorize(roleMap, null);
  authorizing.then(null, function() {
    //authorize rejected -> apply behavior to element
    elementBehaviors[behavior](element);
  });
}
export default angular.module('permission')
  .directive(directives.only, only)
  .directive(directives.except, except)
  .directive(directives.state, state)
  .directive(directives.hasPermission, hasPermission);


/** WEBPACK FOOTER **
 ** ./src/directives/permission.js
 **/